var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 24,
    viewBox: "0 0 122 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 23,
    x: -0.5,
    y: -0.5,
    fill: "#FFF",
    stroke: "#C8C8C8",
    rx: 0.592
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#212121",
    fillOpacity: 0.304,
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
    fontSize: 10
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 14
  }, "dd.mm.yyyy")), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.304,
    d: "M112.496 8H114v8h-8V8h1.5V7h.997v1h3.005V7h.994v1zm.502 7.009v-4.012H107v4.012h5.998zm.004-5.01v-1h-5.993l-.009 1h6.002z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputDate);
export default __webpack_public_path__ + "static/media/inputDate.9316bfe0a6e94c1a0c13e204dce43c05.svg";
export { ForwardRef as ReactComponent };